$(document).ready(function () {
    require("../app/components/user/small_block/small_user.js");
    require("../sync/syncers");


    if($('#external_manager').length > 0) {
        require('../app/components/external/manager.js');
    }

    if($('#imc_notif').length > 0) {
        require('../app/sys/notification/notif.js');
    }

    if (document.getElementById('pos_block')) {
        require('../app/components/pos/pos.js');
    }

    if($("#user_auth").length > 0 ) {
        require('../app/components/user/index.js');
    }

    if($("#user_register").length > 0 ) {
        require('../app/components/user/register');
    }

    if($("#catalog_categories").length > 0 ) {
        require('../app/components/catalog/index.js');
    }

    if($("#orders_view").length > 0 ) {
        require('../app/components/orders/index.js');
    }

    if($("#reviews_block").length > 0 ) {
        require('../app/components/catalog/reviews/review.js');
    }

    if($("#stat_data").length > 0) {
        require('../app/components/dashboard/index.js');
    }

    if($("#organization_filter").length > 0) {
        require('../app/components/catalog/organizations/org_filter.js');
    }

    if($("#user_profile_buttons").length > 0) {
        require('../app/components/user/user_buttons/index.js');
    }

    if($("#user_profile").length > 0) {
        require('../app/components/user/profile/profile.js');
    }

    if($("#modif_block").length > 0) {
        require('../app/components/catalog/modifiers/modifiers.js');
    }

    if($("#export_block").length > 0) {
        require('../app/components/export_users/export.js');
    }

    if($("#delivery_block").length > 0) {
        require('../app/components/deliveries/base/base_delivery.js');
    }

    if($("#review_block").length > 0) {
        require('../app/components/review/base/base_review.js');
    }

    if($("#role_provider").length > 0) {
        require('../app/components/roles/list/base_role.js');
    }

    if($("#pwa_map").length > 0) {
        require('../app/components/aggregators/pwa/pwa_map');
    }

    if($("#pwa_action").length > 0) {
        require('../app/components/aggregators/pwa/pwa_actions');
    }

    if($("#pwa_news").length > 0) {
        require('../app/components/aggregators/pwa/pwa_news');
    }

    if($("#pwa_payments").length > 0) {
        require('../app/components/catalog/payments/pwa_payment_list');
    }

    if($("#pwa_generate").length > 0) {
        require('../app/components/pwa_generate/pwa_generate.js');
    }

    if($("#general_register").length > 0) {
        require('../app/components/user/general_register/general_register.js');
    }

});
